import { Button } from '@repo/design-system-kit';
import { IconSettingsOutlined } from '@repo/monochrome-icons';
import { DialogTrigger, Dialog, Popover } from 'react-aria-components';
import { useIntl } from 'react-intl';
import { type DualNavContextType } from '../contexts';
import styles from './collapsable-footer-menu.module.css';

interface CollapsableFooterMenuProps {
  widthState: DualNavContextType['widthState'];
  children: React.ReactNode;
}

/**
 * Depending on the widthState, this component either displays the footer entries, or a button that display them in a popover on click.
 * **Private** Internal component.
 */
export function CollapsableFooterMenu({ widthState, children }: CollapsableFooterMenuProps) {
  const { formatMessage } = useIntl();

  const isCollapsed = widthState === 'collapsed';

  if (!isCollapsed) {
    return children;
  }

  return (
    <DialogTrigger>
      <Button
        aria-label={formatMessage({ id: 'shared-kit.dual-nav.aria-labels.settings-and-more' })}
        data-testid="footer-menu-button"
        iconOnly
        size="small"
        variant="tertiary"
      >
        <IconSettingsOutlined />
      </Button>
      <Popover placement="top start">
        <Dialog className={styles.dialog}>{children}</Dialog>
      </Popover>
    </DialogTrigger>
  );
}
